import * as React from 'react';
import { SVGProps } from 'react';

const IconLayersSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m3.487 8.65 9.636-5.42a1.781 1.781 0 0 1 1.754 0l9.636 5.42c.65.364.65 1.336 0 1.7l-9.636 5.42a1.782 1.782 0 0 1-1.754 0l-9.636-5.42c-.65-.364-.65-1.336 0-1.7Z" />
    <path d="M4.384 12.749a.855.855 0 0 0 .058.036l8.76 5.002a1.598 1.598 0 0 0 1.595 0l8.76-5.002a.848.848 0 0 0 .059-.036l.898.466a.877.877 0 0 1 0 1.57l-9.637 5.002a1.912 1.912 0 0 1-1.754 0l-9.636-5.002a.877.877 0 0 1 0-1.57l.897-.466Z" />
    <path d="m4.73 16.95 8.473 4.837a1.598 1.598 0 0 0 1.594 0l8.472-4.837 1.245.7c.648.364.648 1.336 0 1.7l-9.637 5.42a1.782 1.782 0 0 1-1.754 0l-9.636-5.42c-.65-.364-.65-1.336 0-1.7l1.244-.7Z" />
  </svg>
);
export default IconLayersSizeL;
